export default __webpack_public_path__ + "static/heldane-text-regular-278d41c6beb416911d9d035280604e51.woff2";